
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1936"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1936"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $iB56l = parcelRequire("iB56l");
var $feaaab957b6da3f7$require$Swiper = $iB56l.default;
var $feaaab957b6da3f7$require$Navigation = $iB56l.Navigation;
var $feaaab957b6da3f7$require$Autoplay = $iB56l.Autoplay;
var $feaaab957b6da3f7$require$Pagination = $iB56l.Pagination;
$feaaab957b6da3f7$require$Swiper.use([
    $feaaab957b6da3f7$require$Navigation,
    $feaaab957b6da3f7$require$Autoplay,
    $feaaab957b6da3f7$require$Pagination
]);
$feaaab957b6da3f7$require$Swiper.use([
    $feaaab957b6da3f7$require$Navigation,
    $feaaab957b6da3f7$require$Autoplay,
    $feaaab957b6da3f7$require$Pagination
]);
const $feaaab957b6da3f7$var$openBtns = document.querySelectorAll('.popup-link');
const $feaaab957b6da3f7$var$modal = document.querySelector('#popup-packages');
let $feaaab957b6da3f7$var$swiperModal;
function $feaaab957b6da3f7$var$initSwiperModal() {
    if (!$feaaab957b6da3f7$var$swiperModal) $feaaab957b6da3f7$var$swiperModal = new $feaaab957b6da3f7$require$Swiper('.modalSwiper', {
        direction: 'horizontal',
        loop: true,
        speed: 400,
        slidesPerView: 1,
        spaceBetween: 30,
        centeredSlides: true,
        navigation: {
            nextEl: $feaaab957b6da3f7$var$modal.querySelector('.swiper-button-next'),
            prevEl: $feaaab957b6da3f7$var$modal.querySelector('.swiper-button-prev')
        }
    });
    else {
        $feaaab957b6da3f7$var$swiperModal.update();
        $feaaab957b6da3f7$var$swiperModal.updateSize();
        $feaaab957b6da3f7$var$swiperModal.updateSlides();
    }
}
$feaaab957b6da3f7$var$openBtns.forEach((btn)=>{
    btn.addEventListener('click', ()=>{
        requestAnimationFrame($feaaab957b6da3f7$var$initSwiperModal);
    });
});


//# sourceMappingURL=en-run.5d1b09a1.js.map
